import React, { Component } from "react";
import images from "./Photos";
import classes from "./RandomPhoto.module.css";

class RandomPhoto extends Component {
  state = {
    image:
      "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/x8AAwMCAO+ip1sAAAAASUVORK5CYII=",
  };

  componentDidMount() {
    this.interval = setInterval(() => {
      this.selectRandomPhoto();
    }, Math.floor(Math.random() * 4 + 1) * 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  selectRandomPhoto = () => {
    this.setState({ image: images[Math.floor(Math.random() * images.length)] });
  };

  render() {
    return (
      <div className={classes.RandomPhoto}>
        <img src={this.state.image} alt="" />
      </div>
    );
  }
}

export default RandomPhoto;
